/**
 * @file Currently just an if statement masqueraded as a React component.
 * In the future this will determine feature contributorPermissions by basename and album type/subtype.
 */

import PropTypes from 'prop-types';

const propTypes = {
  condition: PropTypes.bool,
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.func]).isRequired,
  fallbackContent: PropTypes.any,
};

const FeatureBlock = ({ condition, children, fallbackContent }) => {
  return condition ? children : fallbackContent || null;
};

FeatureBlock.propTypes = propTypes;

export default FeatureBlock;
